import { Component, OnInit } from '@angular/core';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { PartnerCategory } from 'src/app/assabil-kernel/models/entities/control-tables/partner-category-entity';
import { SalesChannel } from 'src/app/assabil-kernel/models/entities/control-tables/sales-channel';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { SalesTransactionsService } from 'src/app/assabil-sales/services/sales-transactions-service';
import { marker } from 'src/app/tools/models/entities/marker';
import { Location } from '@angular/common';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Itinerary } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-entity';
import { GraphhopperService } from 'src/app/assabil-sales/services/graph-hopper-service';
import { ToastrService } from 'ngx-toastr';
import { AgmInfoWindow } from '@agm/core';
import { GraphhopperCluster } from 'src/app/assabil-sales/models/dtos/graph-hopper/graphhopper-cluster';
import { Leg } from 'src/app/tools/models/entities/leg-entity';
import { MyLocation } from 'src/app/tools/models/entities/my-location';

@Component({
  selector: 'app-dispatch',
  templateUrl: './dispatch.component.html',
  styleUrls: ['./dispatch.component.scss']
})
export class DispatchComponent implements OnInit {


  branchs           : Branch[];
  partnerCategorys  : PartnerCategory[];
  salesChannels     : SalesChannel[];

  branch              : Branch = new Branch();
  itineraries         : Itinerary[];
  selectedItineraries : Itinerary[];

  showIitineraries    : boolean = true;

  //--------------------------------------------
  map                 : google.maps.Map;
  latitude            : number = 33.7086152;
  longitude           : number = 7.3501056;
  showMap             : boolean = false;
  styleMap = [{
      featureType: "administrative.country",
      stylers: [{
          visibility: "off"
      }]
  }];
//--------------------------------------------

clustersTab : boolean = false;

//--------------------------------------------
  clustersNumber  : number;
  maxClusters     : number;
  minClusters     : number;
  minWeight       : number = 240;
  maxWeight       : number = 280;
  clusters        : GraphhopperCluster[] = [];
//--------------------------------------------

  partners                  : Partner[] = [];
  totalWeight               : number = 0;
  selectedPartnerTotalWeight: number = 0;

  colors              : string[] = ['green','blue', 'yellow', 'red', 'purple','orange', 'pink'];
  bgColors            : string[] = ['#4fe64d','#6991fd', '#fdf568', ' #f67567', '#8e67fd','#f89903', '#e661ac'];
 

  //colors              : string[] = ['mm_20_purple', 'mm_20_yellow', 'mm_20_blue', 'mm_20_white', 'mm_20_green', 'mm_20_red', 'mm_20_black', 'mm_20_orange', 'mm_20_gray', 'mm_20_brown'];   
  
  /*
  directionsService   : google.maps.DirectionsService;
  directionsRenderer  : google.maps.DirectionsRenderer;
  directionsRenderer2  : google.maps.DirectionsRenderer;
  infowindow          : google.maps.InfoWindow;

  

  itinerarys          : string[] = [];
  
  
  branch              : Branch = new Branch();
  partnerCategoryCode : string;
  salesChannelCode    : string;


  
  options = {
    suppressMarkers: true,
  };

  */
  constructor(
    protected salesTransactionsService : SalesTransactionsService,
    protected controlService           : ControlTablesService,  
    protected masterDataService        : MasterDataService,  
    protected graphhopperService       : GraphhopperService,  
    protected location                 : Location,
    protected toastr                   : ToastrService,
  ) { 
    this.branch.name = "Sélectionner une agence";
  }



//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
ngOnInit(): void {
  this.controlService.getList("branch",         this.controlService.getRequest()).then(result => { 
    this.branchs = result;
  });

  this.controlService.getList("partnerCategory", this.controlService.getRequest()).then(result => { 
    this.partnerCategorys = result;
  });
  
  this.controlService.getList("salesChannel",   this.controlService.getRequest()).then(result => { 
    this.salesChannels = result;
  });
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
close(){
  this.location.back();
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
changeBranch(branch : Branch){
 this.branch = branch;
 this.longitude = branch.longitude;
 this.latitude = branch.latitude;
 //this.map.setZoom(13);

 this.masterDataService.itinerarysGet(null, null, branch.branchCode).then(result => {
  this.itineraries = result;
});
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
selectAllItineraries(){
  for (let it of this.itineraries) {
    it.selected = true;
  }
  this.selectedPartnerTotalWeight = this.totalWeight;
}
unSelectAllItineraries(){
  for (let it of this.itineraries) {
    it.selected = false;
  }
  this.selectedPartnerTotalWeight = 0;
}
onIitineraryChecked(itinerary : Itinerary){
  this.selectedPartnerTotalWeight = 0;
  this.partners.forEach(partner => {
    if (partner.itinerary.selected) this.selectedPartnerTotalWeight += partner.weight;
  });
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
loadData() {
  this.selectedItineraries = [];
  let itinerariesCodes : string[] = [];
  for (let it of this.itineraries) {
    if (it.selected) {
      itinerariesCodes.push(it.itineraryCode);
      let sit = {...it};
      sit.selected = true;
      this.selectedItineraries.push(sit);
    }
  }
  let salesChannelCode : string = null;
  let partnerCategoryCode : string = null;
   
  this.salesTransactionsService.partnersToDispatchGet(itinerariesCodes, salesChannelCode, partnerCategoryCode).then(partners => {    
    this.partners = partners;
    this.totalWeight = 0;
    this.partners.forEach(partner => {
      partner.itinerary = this.findItinerary(partner.itinerary.itineraryCode);
      this.totalWeight += partner.weight;
      this.selectedPartnerTotalWeight += partner.weight;
    });
    this.maxClusters = Math.floor(this.selectedPartnerTotalWeight / this.minWeight);
    this.minClusters = Math.floor(this.selectedPartnerTotalWeight / this.maxWeight);

    this.showMap = true;
  })
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
findItinerary(itineraryCode : string): Itinerary{
  let result : Itinerary = new Itinerary();
  for (let it of this.selectedItineraries){
      if (it.itineraryCode == itineraryCode){
        result = it;
        break;
      }
  }
  return result;
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
onMapReady(map: google.maps.Map) {
  this.map = map;
  //this.initializeMap();
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------




//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
clusterise(){
  let partners : Partner[] = [];
  for (let partner of this.partners){
    if (partner.itinerary.selected) partners.push(partner);
  }

  this.graphhopperService.clusterise(partners, this.clustersNumber, this.minWeight, this.maxWeight).then(graphhopperResponse => {
    if (graphhopperResponse.status != 'finished') {
      this.toastr.error("Error : " + graphhopperResponse.status);
      return;
    }
    this.clusters = graphhopperResponse.clusters;
    let clusterIndex : number = 1; 
    for (let cluster of this.clusters){
      cluster.selected = true;
      cluster.index = clusterIndex++;
      cluster.color = this.getClusterColor(clusterIndex);
      cluster.bgColor = this.getClusterBgColor(clusterIndex);
      let rankInCluster : number = 0; 
      for (let partnerCode of cluster.ids){
          let partner = this.findPartner(partnerCode);
          if (partner) {
            partner.cluster       = cluster;
            partner.rankInCluster = rankInCluster;
            rankInCluster++;
          }
      }
    }
    this.clustersTab = true;
    //this.buildPoints();
  });
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
waypoints   : MyLocation[] = [];
origin      : MyLocation;
destination : MyLocation;
pathCluster : GraphhopperCluster

showPath(cluster : GraphhopperCluster){
  this.pathCluster = cluster;
  this.waypoints = [];
  for (let partnerCode of cluster.ids){
    let partner = this.findPartner(partnerCode);
    let wp : MyLocation = {
      location : {
        lat :  partner.latitude,
        lng : partner.longitude,
      }
    }
    this.waypoints.push(wp);
  }
  this.origin = {
    location : {
      lat : this.branch.latitude,
      lng : this.branch.longitude
  }};
  this.destination = {
      location : {
        lat :  this.branch.latitude,
        lng : this.branch.longitude
   }};
}

getInfoAboutPath(response){
  let distance    : number = 0;
  let duration    : number = 0;
  let legs: Leg[] = [];  
  for(let leg of response.routes[0].legs) {
    distance += leg.distance.value;
    duration += leg.duration.value;
      legs.push({
          distanceValue : leg.distance.value,
          distanceText  : leg.distance.text,
          durationValue : leg.duration.value,
          durationText  : leg.duration.text
      })
  }
  this.pathCluster.distance = distance;
  this.pathCluster.duration = duration;
}

getClusterDistance(cluster : GraphhopperCluster){
  let m = cluster.distance % 1000;
  let km = (cluster.distance - m) / 1000;
    if (cluster.distance) return km  + "km" + m ;
    return "";
} 
getClusterDuration(cluster : GraphhopperCluster){
  //if (cluster.duration) return cluster.duration + "s";
  return "";
} 

//----------------------------------------------------------------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
findPartner(partnerCode : string){
  let result : Partner = null;
  for (let partner of this.partners){
    if (partner.partnerCode == partnerCode){
      result = partner;
      break;
    }
  }
  return result;
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------


selectAllSelectedItineraries(select : boolean){
  for(let it of this.selectedItineraries) {
    it.selected = select;
  }
}
selectAllClusters(select : boolean){
  for(let cluster of this.clusters) {
    cluster.selected = select;
  }
}


//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
getLabel(partner : Partner){
  if (! partner.itinerary.selected) return "";
  if ((partner.cluster) && (! partner.cluster.selected)) return "";
  
  if (!partner.cluster) return "";
  return partner.cluster.index + "";
} 

getBubbleText(partner : Partner){
  let html = "";
  html += "<div>"
  html += partner.name + " <span style='color:red'>" + partner.weight + "</span> <br>" + partner.streetName1
  html += "</div>"
  return html;
} 
getIcon(partner : Partner){
  if (! partner.itinerary.selected) return "http://labs.google.com/ridefinder/images/mm_20_white.png";
  if ((partner.cluster) && (! partner.cluster.selected)) return "http://labs.google.com/ridefinder/images/mm_20_white.png";
  
  let iconUrl = "http://maps.google.com/mapfiles/ms/icons/";
  let color = 'green';
  if (partner.cluster) color = partner.cluster.color;
  iconUrl =  iconUrl + color + ".png";
  return iconUrl;
}

getClusterColor(clusterIndex : number) : string{
  if (clusterIndex == null) return 'green';
  clusterIndex = clusterIndex % 7;
  return this.colors[clusterIndex];
}
getClusterBgColor(clusterIndex : number) : string{
  if (clusterIndex == null) return 'green';
  clusterIndex = clusterIndex % 7;
  return this.bgColors[clusterIndex];
}


markerDragEnd(m: marker, $event) {
  //  console.log('dragEnd', m, $event);
}

onMouseOver(agmInfoWindow: AgmInfoWindow) {
    agmInfoWindow.open();
}
onMouseOut(agmInfoWindow: AgmInfoWindow) {
    agmInfoWindow.close();
}

clickedMarker(point: marker, index: number) {
    
}

placeMarker(event) {
   let lat = event.coords.lat;
   let  lng = event.coords.lng;
}

onClusterChecked(x :any){

}
}
/*

//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
points : marker[] = [];
buildPoints(){
  this.points = [];
  this.partners.forEach(partner => {
    if (partner.itinerary.selected) {
      let point : marker = {     
        lat: partner.latitude,
        lng: partner.longitude,
        label: partner.name,
        tag  : partner.clusterIndex? partner.clusterIndex + "": "",
        draggable: false,
        iconUrl: 'http://maps.google.com/mapfiles/ms/icons/yellow.png'
      };
      this.points.push(point);
    }
  })
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------


        <agm-map  (mapReady)  = "onMapReady($event)" [latitude]="latitude" [longitude]="longitude" 
          [styles]="styleMap" (mapClick)="placeMarker($event)" [fitBounds]="true">
          <agm-marker *ngFor="let partner of partners; let i = index" [latitude]="partner.latitude" [longitude]="partner.longitude"
              [label]="getLabel(partner)"
              [agmFitBounds]="true"
              (markerClick)="clickedMarker(partner, i)" [iconUrl]="getIcon(partner)" [markerDraggable]="draggable"
              (dragEnd)="markerDragEnd(partner, $event)" (mouseOver)="onMouseOver(agmInfoWindow)"
              (mouseOut)="onMouseOut(agmInfoWindow)"
              [animation]="partner.animation">
              <agm-info-window #agmInfoWindow>
                  <div [innerHTML]="getBubbleText(partner)"></div>
              </agm-info-window>
          </agm-marker>




"http://maps.google.com/mapfiles/ms/icons/orange.png";

async initializeMap() {
  this.directionsService = new google.maps.DirectionsService;
  this.directionsRenderer = new google.maps.DirectionsRenderer();
  this.directionsRenderer.setMap(this.map);

  this.directionsRenderer2 = new google.maps.DirectionsRenderer();
  this.directionsRenderer2.setMap(this.map);

  this.map.setZoom(13);
}


path1(){
  let origin      = new google.maps.LatLng(33.7086152, -7.350105600000001);
  let destination = new google.maps.LatLng(33.777696, -7.232545099999999);
  let waypoints : google.maps.DirectionsWaypoint[] = [];

  waypoints.push({ location : new google.maps.LatLng(33.5747267, -7.7080122),          stopover : true});

 this.calculateAndDisplayRoute(origin, destination, waypoints, 1);
}

path2(){
  let origin      = new google.maps.LatLng(33.5957099, -7.678016400000001);
  let destination = new google.maps.LatLng(33.5350395, -7.7651023);
  let waypoints : google.maps.DirectionsWaypoint[] = [];
 
  waypoints.push({ location : new google.maps.LatLng(33.562279,  -7.614747800000001),  stopover : true});
  waypoints.push({ location : new google.maps.LatLng(33.6012201, -7.661741800000001),  stopover : true});


 this.calculateAndDisplayRoute(origin, destination, waypoints, 2);
}



//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
onMapClick(point : LatLngLiteral){
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
setBranch(){
  let point : marker = {     
    lat: this.branch.latitude,
    lng: this.branch.longitude,
    label: this.branch.name,
    draggable: false,
    iconUrl: 'http://maps.google.com/mapfiles/ms/icons/yellow.png'
  };
  this.points.push(point);

  this.buildRoute();
}
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------


//----------------------------------------------------------------------------------------------------------------------------------------------------------------------
origin      : any;
destination : any;
waypoints   : any[] = [];
buildRoute(){
  this.waypoints =  [];
  this.partners.forEach(partner => {
    if ( this.waypoints.length < 25) this.waypoints.push({ location : {lat : partner.latitude, lng: partner.longitude},   stopover : true});
  });

  this.origin       = { location : {lat : this.branch.latitude, lng: this.branch.longitude}};
  this.destination  = { location : {lat : this.branch.latitude, lng: this.branch.longitude}};

  //this.calculateAndDisplayRoute(origin, destination, waypoints);

}



  calculateAndDisplayRoute(origin: google.maps.LatLng, destination: google.maps.LatLng, waypoints: google.maps.DirectionsWaypoint[], path : number) {
    let request: google.maps.DirectionsRequest;
  
    request = {
      origin            : origin,
      destination       : destination,
      waypoints         : waypoints,
      optimizeWaypoints : true, //set to true if you want google to determine the shortest route or false to use the order specified.
      travelMode        : google.maps.TravelMode.DRIVING
    };

    this.directionsService.route(request, (response, status) => {
      if (status != google.maps.DirectionsStatus.OK) {         window.alert("Directions request failed due to " + status); return; }
      console.log(response);
      this.directionsRenderer.setRouteIndex(path-1);
      this.directionsRenderer.setDirections(response);
      //if (path ==  1) this.directionsRenderer.setDirections(response);
      //if (path ==  2) this.directionsRenderer2.setDirections(response);
    });
  }
*/


/* waypoints.push({ location : new google.maps.LatLng(33.6036369, -7.549303599999999),  stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.588172,  -7.617603999999999),  stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.575705,  -7.615434800000001),  stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.562603,  -7.594245),           stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.5955839, -7.6174119),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.7776961, -7.232555700000001),  stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.5857102, -7.6350357),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.5947834, -7.633328799999999),  stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.544315,  -7.640514),           stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.5994607, -7.6126671),          stopover : true});

waypoints.push({ location : new google.maps.LatLng(33.593541, -7.5859394),          stopover : true});
  waypoints.push({ location : new google.maps.LatLng(33.503541, -7.5849394),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.593541, -7.5879394),          stopover : true});
    waypoints.push({ location : new google.maps.LatLng(33.6903541, -7.5829394),          stopover : true});
waypoints.push({ location : new google.maps.LatLng(33.593541, -7.5199394),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.690541, -7.5599394),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.690541, -7.5699394),          stopover : true});

 waypoints.push({ location : new google.maps.LatLng(33.503541, -7.6899394),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.690541, -7.6599394),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.6103541, -7.5899394),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.5803541, -7.6899394),          stopover : true});
 waypoints.push({ location : new google.maps.LatLng(33.5703541, -7.6899394),          stopover : true});
*/